"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_DASHBOARD = void 0;
var client_1 = require("@apollo/client");
exports.GET_DASHBOARD = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetDashboard($input: DashboardInput!) {\n    dashboard(input: $input) {\n      storesCount\n      storesNeedAudits\n      storesNoImages\n    }\n  }\n"], ["\n  query GetDashboard($input: DashboardInput!) {\n    dashboard(input: $input) {\n      storesCount\n      storesNeedAudits\n      storesNoImages\n    }\n  }\n"])));
var templateObject_1;
